import {
  Button as MuiButton,
  Card as MuiCard,
  CardActionArea as MuiCardActionArea,
  CardActions,
  CardContent as MuiCardContent, Grid,
  Typography as MuiTypography
} from "@material-ui/core";
import styled from "styled-components/macro";
import { spacing } from "@material-ui/system";
import React, {FC, useEffect, useState} from "react";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import {Box} from "@mui/material";
import {urls, useRouting} from "../../../../routes";
import PublishedWidget from "./PublishedWidget";
import {useSelector} from "../../../../redux/store";
import {IUser} from "../../../../models/User";
import {getUserProfile} from "../../../../selectors";

const Card = styled(MuiCard)(spacing);
const Button = styled(MuiButton)`
  padding: 0;
  background-image: linear-gradient(90deg, #84FAB0 0%, #8FEAFE 100%);
  -webkit-background-clip: text;
  color: transparent;
  &.Mui-disabled {
    //color: gray !important;
    background-image: unset;
  }
  &:hover {
    background-image: linear-gradient(90deg, #ccffdd 0%, #cdf6ff 100%);
  }
`;
const Typography = styled(MuiTypography)(spacing)
const CardContent = styled(MuiCardContent)`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`

const CardActionArea = styled(MuiCardActionArea)`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  &:hover {
    cursor: default;
  },
`
const CompanyCell = styled.div`
  background: #a0a0a01c; 
  border-radius: 5px; 
  padding: 3px 10px
`

const useStyles = makeStyles({
  button: {
    padding: "0px",
    backgroundImage: 'linear-gradient(90deg, #84FAB0 0%, #8FEAFE 100%)',
    '-webkit-background-clip': 'text',
    color: 'transparent'
  },
  card: {
    height: '100%',
  },
  name: {
    textAlign: "start",
    width: "100%"
  },
  createdDate: {
    textAlign: "start",
    width: "100%",
    textTransform: "capitalize"
  },
  cardActions: {
    borderTop: "1px solid #EEEEEE",
    padding: "10px 0px 10px 15px"
  },
  actionArea: {
    "&:hover $focusHighlight": {
      opacity: 0
    }
  },
  focusHighlight: {}
})

type PropsType = {
  id: string
  name: string
  createdAt: string
  published: boolean
  general_image: null | string
  companyName: string
}

const PropertyCard: FC<PropsType> = ({
  id,
  name,
  createdAt,
  published,
  general_image,
  companyName
}) => {
  const { t, i18n } = useTranslation()
  const classes = useStyles()
  const { routeTo } = useRouting()
  const [viewLiveWidgetButton, setViewLiveWidgetButton] = useState(published)
  const userProfile = useSelector<IUser | undefined>(getUserProfile);

  const handleEditWidget = () => {
    routeTo(urls.editWidget, { id })
  }

  const handleOpenLiveWidget = () => {
    window.open(`https://amswidget-accessibility-dev.handiscover.com/page/property/${id}`, '_blank')
  }

  return (
    <Card className={classes.card}>
      <CardActionArea classes={{
        root: classes.actionArea,
        focusHighlight: classes.focusHighlight
      }} style={{position: 'relative'}}>
        {general_image ? (
          <img src={general_image} alt="General Image" style={{
            height: '100%',
            width: '100%',
            objectFit: 'cover',
            filter: 'brightness(0.3)',
            position: 'absolute'
          }}/>
        ) : null}
        <CardContent style={{zIndex: 1}}>
          <Box display='flex' flexDirection='column' justifyContent='space-between' height='100%' style={{minHeight: '180px'}}>
            <Box display='flex' flexDirection='column' style={{flexGrow: 1}}>
              <Typography className={classes.name} variant="h4" gutterBottom display="inline">
                {name}
              </Typography>
              {userProfile?.is_staff ? (
                <Box mb={2} display={'flex'}>
                  <CompanyCell>
                    <b>{t("signupForm_signUp_companyLabel")}:</b> {companyName}
                  </CompanyCell>
                </Box>
              ) : null}
              <Typography className={classes.createdDate} variant="body1" gutterBottom display="inline">
                {`${new Date(createdAt).toLocaleDateString(
                  i18n.language,
                  {
                    year: 'numeric',
                    month: '2-digit',
                    day: "2-digit"
                  }
                )} ${t('created')}`}
              </Typography>
            </Box>
            <PublishedWidget
              propertyId={id}
              published={published}
              onChange={(e) => setViewLiveWidgetButton(e.target.checked)}
            />
          </Box>
        </CardContent>
      </CardActionArea>
      <CardActions className={classes.cardActions}>
        <Box mr={2.5}>
          <Button
            size="small"
            onClick={handleEditWidget}
          >
            {t('edit_widget')}
          </Button>
        </Box>
        <Button
          size="small"
          disabled={!viewLiveWidgetButton}
          onClick={handleOpenLiveWidget}
        >
          {t('view_live_widget')}
        </Button>
      </CardActions>
    </Card>
  )
}

export default PropertyCard
